import { render, staticRenderFns } from "./CitasConfirmacion.vue?vue&type=template&id=04db8ed6&"
import script from "./CitasConfirmacion.vue?vue&type=script&lang=js&"
export * from "./CitasConfirmacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports